import * as React from 'react';

import { selectIsAuthenticated } from '../../selectors/isAuthenticated';
import { selectNewbuildingBrokerSelfRequestFormWidgetLoading } from '../../selectors/newbuildings/newbuildingBrokerSelfRequestFormWidget';
import {
  fetchUser,
  setNewbuildingBrokerSelfRequestFormWidgetActive,
  setNewbuildingBrokerSelfRequestFormWidgetLoading,
} from '../../slices/newbuildingBrokerSelfRequestFormWidgetSlice';
import { requestAuthentication } from '../../thunks';
import { useAppDispatch, useAppSelector as useSelector } from '../../types';
import { trackNewbuildingBrokerWidgetBannerClick } from './analytics/analytic';

export const useNewbuildingBrokerWidgetBanner = () => {
  const dispatch = useAppDispatch();

  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isLoading = useSelector(selectNewbuildingBrokerSelfRequestFormWidgetLoading);

  const activateWidget = React.useCallback(async () => {
    dispatch(setNewbuildingBrokerSelfRequestFormWidgetLoading(true));
    await dispatch(fetchUser());
    dispatch(setNewbuildingBrokerSelfRequestFormWidgetActive(true));
  }, [dispatch]);

  const clickHandler = React.useCallback(() => {
    trackNewbuildingBrokerWidgetBannerClick();

    if (!isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: activateWidget,
        }),
      );

      return;
    }

    activateWidget();
  }, [activateWidget, dispatch, isAuthenticated]);

  return {
    isLoading,
    clickHandler,
  };
};
